// Mock data for CareHR landing page (frontend-only foundation)

export const brand = {
  name: "CareHR",
  tagline: "Healthcare Workforce Network",
  mission: "Healthcare People. A Healthier Tomorrow.",
};

export const nav = [
  { label: "About", href: "#about" },
  { label: "Contact", href: "#contact" },
];

export const hero = {
  eyebrow: "HEALTHCARE PEOPLE. A HEALTHIER TOMORROW.",
  titleLead: "Two Goals.",
  titleAccent: "One Platform.",
  subtitle:
    "Connecting healthcare organisations and professionals for a stronger healthcare system.",
  script: ["People", "Build", "Healthcare"],
};

export const organisation = {
  kicker: "I AM A",
  title: ["Healthcare", "Organisation"],
  lead: "Find the right people for your team.",
  description:
    "Hospitals, clinics, diagnostic centres, labs, healthcare companies and more.",
  actions: [
    { id: "post-requirement", label: "Post a Requirement — Free", icon: "Building2", variant: "primary" },
    { id: "browse-professionals", label: "Browse Registered Professionals", icon: "Users", variant: "outline" },
  ],
  features: [
    { icon: "Search", lines: ["Reach", "qualified talent"] },
    { icon: "Clock", lines: ["Save time", "in hiring"] },
    { icon: "UsersRound", lines: ["Build a", "stronger team"] },
  ],
  image:
    "https://images.pexels.com/photos/18470744/pexels-photo-18470744.jpeg",
  script: ["Better", "Teams", "Better Care"],
};

export const professional = {
  kicker: "I AM A",
  title: ["Healthcare", "Professional"],
  lead: "Discover opportunities that match your skills and goals.",
  description:
    "Doctors, nurses, paramedical staff, technicians, pharmacists, administrators and more.",
  actions: [
    { id: "find-opportunities", label: "Find Opportunities", icon: "Search", variant: "primary" },
    { id: "tell-us", label: "Tell Us What You're Looking For", icon: "FileText", variant: "outline" },
  ],
  features: [
    { icon: "Target", lines: ["Find relevant", "opportunities"] },
    { icon: "BarChart3", lines: ["Grow your", "career"] },
    { icon: "UserRound", lines: ["Connect directly", "with organisations"] },
  ],
  image:
    "https://images.pexels.com/photos/6129499/pexels-photo-6129499.jpeg",
  script: ["Your", "Next Chapter", "Starts Here"],
};

export const footer = {
  links: ["About", "Contact", "Terms", "Privacy"],
  copyright: "© 2024 CareHR. All rights reserved.",
  tagline: "Healthcare People. A Healthier Tomorrow.",
};
